var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bubly-hamburger_container",class:{ open: _vm.state }},[_c('button',{staticClass:"bubly-hamburger",attrs:{"aria-expanded":_vm.state,"aria-label":_vm.state ? 'Close navigation menu' : 'Open navigation menu'},on:{"click":_vm.toggle}},[_c('span',{staticClass:"bubly-hamburger_inner"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e45b824","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/Hamburger.vue
// module id = null
// module chunks = 